(function () {
    'use strict';

    angular.module("product")
        .controller('ProductLogApplyManyModalController', ProductLogApplyManyModalController);

    ProductLogApplyManyModalController.$inject = ['products', '$uibModalInstance', 'productDataSrvc', 'notificationSrvc', 'productMessagesConst', 'errorNotificationSrvc'];

    function ProductLogApplyManyModalController(products, $uibModalInstance, productDataSrvc, notificationSrvc, productMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.products = [];
        self.selectedProducts = products;
        self.productData = {
            item: null
        };
        self.importData = {
            product: null
        };
        self.loading = false;
        self.skippedRows = [];
        self.skippedCols = [{
            title: 'ID produktu',
            value: 'product',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Akcja',
            value: 'action',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Model',
            value: 'model',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Dane',
            value: 'data',
            type: 'json',
            searchable: false,
            orderable: false
        }];
        self.imported = false;

        self.ok = ok;
        self.cancel = cancel;
        self.onProductSearch = onProductSearch;
        self.onProductChange = onProductChange;

        activate();

        function activate() {
            getProducts();
        }

        function ok() {
            if (self.importData.product) {
                self.loading = true;
                self.imported = false;

                productDataSrvc.applyManyProductLog({
                    product_to_apply: self.importData.product,
                    products: self.selectedProducts
                }).$promise.then(
                    function (response) {
                        self.loading = false;
                        notificationSrvc.notification("success", productMessagesConst.update);
                        self.skippedRows = response;
                        self.imported = true;

                        if (!self.skippedRows.length) {
                            $uibModalInstance.close(self.importData.product);
                        }
                    },
                    function (response) {
                        self.loading = false;
                        self.imported = true;
                        errorNotificationSrvc.displayErrors(response.data)
                    }
                );
            }
        }

        function cancel() {
            if (self.imported) {
                $uibModalInstance.close(self.importData.product);
            } else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function getProducts() {
            return productDataSrvc.optionsList().$promise.then(
                function (response) {
                    self.products = response.results;
                    return response;
                }
            )
        }

        function onProductSearch(params) {
            if (!params) {
                params = {};
            }
            return productDataSrvc.optionsList(
                params
            ).$promise;
        }

        function onProductChange(product) {

        }
    }
})();
